/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */

module platform {

   import IInjectorService = angular.auto.IInjectorService;

   export class ClientLocaleServiceWrapper {
      static $inject = ['$injector'];
      private _vcClientLocaleService: ClientLocaleServiceWrapper;

      constructor(private $injector: IInjectorService) {
      }

      get vcClientLocaleService(): ClientLocaleServiceWrapper {
         if (!this._vcClientLocaleService) {
            this._vcClientLocaleService = this.$injector.get('vcClientLocaleService');
         }
         return this._vcClientLocaleService;
      }

      get() {
         return this.vcClientLocaleService.get();
      }
   }

   /**
    * @ngdoc service
    * @name com.vmware.platform.ui.clientLocale
    * @module com.vmware.platform.ui
    *
    * @description
    *    Client locale Service.
    */
   angular.module('com.vmware.platform.ui').service('clientLocale', ClientLocaleServiceWrapper);
}
